import { COMMUNITY_CONTRACT_TYPE } from '../constants';

export const COMMUNITY_RENTAL_TYPE = {
  RENTAL: 10,
  CCRC: 20,
};

export const COMMUNITY_RENTAL_TYPE_LABELS = {
  [COMMUNITY_RENTAL_TYPE.RENTAL]: 'Rental',
  [COMMUNITY_RENTAL_TYPE.CCRC]: 'Life Plan',
};

export const COMMUNITY_CCRC_CONTRACT_TYPES = [
  COMMUNITY_CONTRACT_TYPE.TYPE_A,
  COMMUNITY_CONTRACT_TYPE.TYPE_B,
  COMMUNITY_CONTRACT_TYPE.TYPE_C,
];

export const COMMUNITY_CCRC_CONTRACT_TYPES_LABELS = {
  [COMMUNITY_CONTRACT_TYPE.TYPE_A]: 'Contract Type A',
  [COMMUNITY_CONTRACT_TYPE.TYPE_B]: 'Contract Type B',
  [COMMUNITY_CONTRACT_TYPE.TYPE_C]: 'Contract Type C',
};
